<template>
  <section v-if="reviews && reviews.length">
    <div :key="review._id" class="inner" v-for="review in reviews.slice(0,1)">
      <p class="quote">
        <font-awesome-icon icon="quote-left" />
        {{ review.quote }}
        <font-awesome-icon icon="quote-right" />
      </p>
      <p class="label">{{ review.name }}</p>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(["reviews"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
section {
  text-align: center;
  padding: 4rem 0;
  line-height: 1.8;
  background: #53453c;
  color: white;
}

p.quote {
  max-width: 1000px;
  margin: auto;
  font-size: 2.5rem;
}

.quote svg {
  color: #ccb298;
  font-size: 2rem;
  margin: 0 2rem;
  vertical-align: text-top;
}

@media screen and (max-width: 750px) {
  p.quote {
    font-size: 2.5rem;
  }
}
</style>
